import { ImportedEventAnalyticsEvents, platform } from '../Analytics/constants';
import { trackEvent } from '../Analytics/TrackedClick';

// Both imported-event events are emitted from here so the payload shape has one home. The page
// view is driven by a hook (useImportedEventPageTracking) because its timing depends on render
// state; the share is a plain call because one of its callers is a class component.

export const trackImportedEventViewed = ({
    eventId,
    entryPoint,
    importedEventType,
    importSource,
    userSubscriptionType,
}) => {
    if (!eventId) {
        return;
    }

    trackEvent(ImportedEventAnalyticsEvents.PAGE_VIEWED, {
        ImportedEventId: eventId,
        entryPoint: entryPoint ?? null,
        importedEventType: importedEventType ?? null,
        importSource: importSource ?? null,
        UserSubscriptionType: userSubscriptionType,
        platform,
    });
};

// `shareSurface` distinguishes a share taken on the Imported Event Page itself from one taken on
// an imported event card on a player profile. Callers fire this only once the copy has actually
// succeeded, so the event marks a completed share rather than a tap.
export const trackImportedEventShared = ({ eventId, shareSurface }) => {
    if (!eventId) {
        return;
    }

    trackEvent(ImportedEventAnalyticsEvents.PAGE_SHARED, {
        ImportedEventId: eventId,
        shareSurface,
        platform,
    });
};
